(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ma-hawa-product-cart-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ma-hawa-product-cart-progress')) {
    customElements.define(
      'ma-hawa-product-cart-progress',
      class MaHawaProductCartProgress extends HTMLElement {
        connectedCallback() {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
          } else {
            this.initialize();
          }
        }

        initialize() {
          if (this.isInitialized) return;
          this.isInitialized = true;
          this.minimumOrder = Number(this.dataset.minimumOrder) || 5;
          this.qualifyingProductIds = new Set(
            (this.dataset.minimumProductIds || '').split(',').map((id) => id.trim()).filter(Boolean)
          );
          this.progressBar = this.querySelector('[data-product-cart-progress]');
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              const cart = event && event.cartData;
              if (cart && typeof cart.item_count !== 'undefined' && Array.isArray(cart.items)) {
                this.update(cart);
              } else {
                this.refreshCart();
              }
            });
          }
          this.refreshCart();
        }

        disconnectedCallback() {
          if (this.unsubscribeCart) this.unsubscribeCart();
          this.isInitialized = false;
        }

        async refreshCart() {
          try {
            const response = await fetch(`${window.routes.cart_url}.js`, {
              headers: { Accept: 'application/json' },
            });
            if (!response.ok) return;
            this.update(await response.json());
          } catch (cartError) {
            return;
          }
        }

        update(cart) {
          if (!this.progressBar) return;
          const itemCount = Number(cart.item_count) || 0;
          const qualifyingCount = (cart.items || []).reduce((total, item) => {
            if (!this.qualifyingProductIds.has(String(item.product_id))) return total;
            return total + (Number(item.quantity) || 0);
          }, 0);
          const summary = this.progressBar.querySelector('[data-cart-summary]');
          const fill = this.progressBar.querySelector('[data-progress-fill]');
          const total = this.progressBar.querySelector('[data-cart-total]');

          this.progressBar.hidden = itemCount === 0;
          if (summary) {
            summary.textContent = this.fillTemplate(this.dataset.summaryTemplate, {
              items: itemCount,
              current: qualifyingCount,
            });
          }
          if (fill) fill.style.width = `${Math.min(100, (qualifyingCount / this.minimumOrder) * 100)}%`;
          if (total) total.textContent = this.formatMoney(cart.total_price, cart.currency);
        }

        fillTemplate(template, values) {
          return Object.entries(values).reduce(
            (result, [key, value]) => result.replaceAll(`[${key}]`, String(value)),
            template || ''
          );
        }

        formatMoney(cents, currency) {
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: currency || 'AED',
            }).format((Number(cents) || 0) / 100);
          } catch (formatError) {
            return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency || 'AED'}`;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
